import { registerName, SHIPPED_REGISTER_NAMES, tt } from '@agos/shared'

/**
 * Which registers *Zaplatiť* offers - `FRONTEND.md` §9.740, `BACKEND.md` §10A.388, owner O110.
 *
 * **The owner (Sereď)**: *"osobný odber v Seredi sa tlačí aj na reštaurácii aj na rozvoze"* - and *Kasa rozvoz*
 * and *Kasa rozvoz Terminál* are one device that differs only in whether it drives the card terminal, so the
 * register is how the person at the till says whether the card goes through the terminal. A channel both on the
 * premises and driven may name the registers it prints on (`printRegistersOf`), and then the till offers those.
 *
 * - **No list** - the select is what it always was: *Podľa kanála* and every register, nothing chosen, because the
 *   channel's own register is nearly always right (§10A.17).
 * - **One register** - offered and chosen, since there is nothing left to decide.
 * - **Two or more** - offered, and **none chosen**: §10A.17's own comment refuses to preselect a guess, *"showing a
 *   guess as a choice makes a person confirm something nobody decided"*, and here the guess would decide whether
 *   a card is charged on the terminal. The payment waits for a choice ({@link kasaProblem}).
 */
export interface RegisterOption {
  id: string
  label: string
}

export interface RegisterChoice {
  options: RegisterOption[]
  /** The channel names its registers, so there is no *Podľa kanála* and printing needs one of them. */
  listed: boolean
  /** The register to start with - the one listed register, or `''`. */
  initial: string
}

export function registerChoice(
  listed: readonly string[],
  every: readonly RegisterOption[],
  rows: readonly { kasaId?: string | null; label?: string | null }[],
): RegisterChoice {
  if (listed.length === 0) return { options: [...every], listed: false, initial: '' }
  return {
    // Named the way every other register list names them, so the till and the settings say the same word.
    options: listed.map((id) => ({ id, label: registerName(id, rows, SHIPPED_REGISTER_NAMES) })),
    listed: true,
    initial: listed.length === 1 ? (listed[0] ?? '') : '',
  }
}

/** Why the receipt cannot be printed yet, or null - only a listed channel can be waiting for a register. */
export function kasaProblem(choice: RegisterChoice, kasaId: string): string | null {
  if (!choice.listed) return null
  return choice.options.some((option) => option.id === kasaId)
    ? null
    : tt('Vyberte kasu, na ktorej sa doklad vytlačí.')
}
